import { Popup } from '../../../../../components/Popup'
import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { BTN_TXT, LABELS } from '../../../../../constants'
import { useContractDetailsPopup } from '../../../Providers/ContractDetailsPopupProvider'
import { Typography } from '../../../../../components/Typography'
import { Form } from 'antd'
import { CustomForm } from 'components/Forms/CustomForm'
import { validateMessages } from '../../../../../helper/common'
import cn from 'classnames'
import { TAddSignatoryForm } from './types'

import { useContractDetailsContext } from '../../../Providers/ContractDetailsContextProvider'

import { AddSignatorySelect } from './AddSignatorySelect'
import { getAvailableUsersForSignatory } from '../../../api'
import { useParams } from 'react-router-dom'
import { useEffect, useMemo } from 'react'

export const AddSignatoryPopup = () => {
  const contractDetailsContext = useContractDetailsContext()
  const {
    addSignatoryPopup: { state, actions }
  } = useContractDetailsPopup()

  const { id } = useParams()

  const { signatoriesToReassign } = contractDetailsContext.state

  const { documentId } = state.payload

  const signatoryToReassign = useMemo(
    () =>
      signatoriesToReassign.find((item) => item.document === documentId)
        ?.signatory,
    [signatoriesToReassign, documentId]
  )

  useEffect(() => {
    if (signatoryToReassign && state.visible) {
      form.setFieldsValue({
        signatory:
          signatoryToReassign.signatory?.uuid ?? signatoryToReassign.email
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signatoryToReassign, state])
  const {
    actions: { addSignatory, reassignSignatory }
  } = useContractDetailsContext()

  const [form] = Form.useForm<TAddSignatoryForm>()

  useEffect(() => {
    if (!state.visible) form.resetFields()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.visible])

  const onClose = () => {
    actions.close()
    form.resetFields()
  }

  return (
    <Popup
      {...state}
      title={signatoryToReassign ? 'Reassign a Signatory' : state.title}
      className="add-signatory-modal"
      onCancel={onClose}
      width={442}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} upperCase onClick={onClose}>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            upperCase
            form="add-signatory-form"
            htmlType="submit"
          >
            {signatoryToReassign ? BTN_TXT.REASSIGN : BTN_TXT.ADD}
          </Button>
        </>
      }
    >
      <div className="gap-16 column full-width">
        <Typography.Body2 className="add-signatory-modal__hint">
          The selected signatory will receive the document for signing once
          community and vendor approvals are finalized.
        </Typography.Body2>
        <CustomForm<TAddSignatoryForm>
          form={form}
          noValidate={true}
          onFinish={(values) =>
            signatoryToReassign
              ? reassignSignatory(values, documentId)
              : addSignatory(values, documentId)
          }
          validateMessages={{
            ...validateMessages,
            types: {
              email: 'Enter a valid email'
            }
          }}
          id="add-signatory-form"
          className={cn('add-signatory-form add-edit-event-calendar-form')}
        >
          <div className="column gap-16">
            <AddSignatorySelect
              form={form}
              selectPropsItem={{ label: LABELS.SIGNATORY, name: 'signatory' }}
              optionsRequest={() => getAvailableUsersForSignatory(id)}
            />
          </div>
        </CustomForm>
      </div>
    </Popup>
  )
}
